import { StatisticsView } from "./_components";

export default function StatisticsPage() {
  return <StatisticsView />;
}
